import { useWizard } from "react-use-wizard";
import { IFillDataWizardSell, TKeyOfDataWizardSell } from "../..";
import FeaturesFacilityStep, {
  IDataFeatures,
} from "../../../../../../shared/wizard/steps/featuresStep";
import sellSteps from "../sellSteps";

interface IDoNotKnowPrice_2 {
  onChange: (data: Partial<IFillDataWizardSell>) => void;
  data: Partial<IFillDataWizardSell>;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardSell[]) => void;
}

const DoNotKnowPrice_2 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: IDoNotKnowPrice_2) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.doNotKnowPrice.step_1);
    onReset([
      "debt",
      "arrest",
      "encumbrance",
      "childrenOwn",
      "privatization",
    ]);
  };

  const handleNexStep = () => {
    goToStep(sellSteps.doNotKnowPrice.step_3);
  };

  return (
    <div>
      <FeaturesFacilityStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data as IDataFeatures}
      />
    </div>
  );
};

export default DoNotKnowPrice_2;
